import styled from "@emotion/styled";

export const WorkspaceItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  width: 560px;
  box-sizing: border-box;
  cursor: pointer;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const WorkspaceImageContainer = styled.img`
  background-color: white;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  border: none;

  object-fit: cover;
  object-position: center;
`;

export const WorkspaceEmptyImageConainer = styled.div`
  background-color: #d9d9d9;
  width: 48px;
  height: 48px;
  border-radius: 8px;
`;

export const WorkspaceInfoContainer = styled.div`
  width: 476px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const WorkspaceProfile = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const UserProfile = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  min-width: 1px;
  width: 1px;
  height: 32px;
  background-color: var(--alias-color-line-normal);
`;

export const IconContainer = styled.div`
  margin-left: 20px;
`;

export const WorkspaceItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
